<template>

</template>
<script>
import Checkbox from "../Components/Checkbox/index";
import Axios from "axios";
export default {
  name: "SidbarProcess",
  props: ["installmentID"],

  data: () => ({
    shippingAddress: {},
    installmentPaymentId: "",
    rules: false,
    checkoutAnswer: {},
    shippingCost: "",
    installmentResponse: {},
  }),
  emits: ["updateshowText"],
  components: {  Checkbox },
  methods: {

  },

  mounted() {
    this.emitter.on("shippingCost", (shippingCost) => {
      this.shippingCost = shippingCost;
    });
    this.cartId = localStorage.getItem("cartId");
    localStorage.removeItem("cart");
    this.checkout();
    this.emitter.on("installmentResponse", (installmentResponse) => {
      this.installmentResponse = installmentResponse;
    });
    this.installmentResponse = false;

    this.emitter.on("shippingAddress", (shippingAddress) => {
      this.shippingAddress = shippingAddress;
    });
    this.emitter.on("installmentPaymentId", (installmentPaymentId) => {
      this.installmentPaymentId = installmentPaymentId;
    });
  },
  computed: {
    computedFinalCost() {
      let finalCost;
      finalCost = this.shippingCost + this.checkoutAnswer.totalCost;
      return finalCost;
    },
  },
};
</script>
<style lang="scss">


.title_sidbarProcess {
  display: flex;
  justify-content: center;

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: var(--mainFont);
  }
}



.text_content_sidbarProcess {
  display: flex;
  justify-content: space-between;

  h6,
  h4,
  h5,
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: var(--mainFont);
  }

  h3 {
    font-size: 16px;
  }
}

.details_content_sidbar {
  display: flex;
  flex-direction: column;
}

.line_content_sidbarProcess {
  border: 1px dashed #3dd2b8;
}

.btn_sidbarProcess {
  .v-btn {
    .v-btn__content {
      justify-content: center !important;
      box-shadow: transparent !important;
    }
  }
}

.checkbox_sidbar {
  label {
    font-size: 15px;
    font-weight: 600;
    color: var(--mainFont);
  }
}

@media only screen and (max-width: 768px) {}
</style>
